export const apiKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweEJFOGY5MWZENTJmMGI4MTRGN2ZFNjdkNzcyQTJDRjE0RjkyNTU0ODgiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY0NDEyMzU4MTM4NywibmFtZSI6InVwY29taW5nIHNwb3J0cyBzdGFycyJ9.gQARtoKY3enVMwL35t5FjGRjvb_q2jWFujVMAAq7X6U'
